import { Request } from "@cttq/cttq-request";
const getHeader = () => {
	const headers = {
		appSource: import.meta.env.VITE_SOURCE,
		reqSource: "app"
	};
	return headers;
};

const BaseRequestInstance = new Request({
	baseURL: import.meta.env.VITE_BASE_URL,
	showLoading: true,
	showError: true,
	timeout: 180000,
	cancelRequest: true,
	headers: getHeader(),
	requestInterceptors: (config: any) => {
		// 请求拦截器
		return config;
	},
	responseInterceptors: (response: any) => {
		// 响应拦截器
		return response.data;
	}
});
export { BaseRequestInstance };
